import React, { useState } from "react";
import "./Home.css"; // Assuming you have the CSS for styling

const testimonials = [
  {
    name: "Ankit Sharma",
    image: "images/ankit_sharma.jpg", // Replace with your image path
    designation: "Founder, TechNova Pvt. Ltd.",
    rating: 5,
    text: "They knew exactly what I needed.",
    details: "Ankit Sharma has been working in the industry for over 10 years and is known for his expertise in leading tech innovations."
  },
  {
    name: "Rahul Desai",
    image: "images/rahul_desai.jpg", // Replace with your image path
    designation: "Director, Buildight Constructions",
    rating: 4,
    text: "MPS Global made the entire company registration process effortless. I had everything sorted without running around different consultants. Their team truly understands what entrepreneurs need.",
    details: "Rahul Desai has helped numerous construction businesses scale through optimized processes and strategic growth strategies."
  },
  {
    name: "Ritika Verma",
    image: "images/ritika_verma.jpg", // Replace with your image path
    designation: "Managing Director, UrbanNest Interiors",
    rating: 4.5,
    text: "I was impressed with how professional and quick their services were. They handled everything with such ease and I’m now confidently scaling my business.",
    details: "Ritika Verma is a passionate leader in the interior design space with a focus on innovation and sustainable practices."
  },
];

const questions = [
  {
    question: 'How long does it take to register a Private Limited Company with MPS Global?',
    answer: 'On average, our experts can get your company registered within 7-10 working days, depending on document readiness and approvals.',
  },
  {
    question: 'Do I really need a CA or CS for starting my business?',
    answer: 'While not legally mandatory, having a CA or CS ensures that your company meets all regulatory requirements and is structured efficiently.',
  },
  {
    question: 'Can you help me with legal drafting like MOA, AOA, or agreements?',
    answer: 'Yes, we offer comprehensive legal services for drafting MOA, AOA, and other essential agreements for your business.',
  },
  {
    question: 'Do you provide end-to-end support for GST, TDS, and other compliances?',
    answer: 'Absolutely! We offer end-to-end services for all necessary tax and regulatory compliances, including GST, TDS, and more.',
  },
  {
    question: 'Is there any ongoing support after the initial registration?',
    answer: 'Yes, we provide continuous support for all your compliance needs, including tax filings, statutory audits, and other ongoing requirements.',
  },
];

const teamMembers = [
  {
    name: "Mrs. Ankita Jain",
    image: "images/team3.svg", // Replace with the correct image path
    role: "Chartered Accountant",
  },
  {
    name: "Miss. Prachi Malviya",
    image: "images/prachi_malviya.jpg", // Replace with the correct image path
    role: "Company Secretary",
  },
  {
    name: "Mrs. Chaitali Wadnere",
    image: "images/team3.svg", // Replace with the correct image path
    role: "Sr. Finance Analyst",
  },
  {
    name: "Miss. Aboli Deo",
    image: "images/aboli_deo.jpg", // Replace with the correct image path
    role: "Lawyer",
  },
];

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const navigateToContact = () => {
  scrollToTop();  // Scroll to the top smoothly
  window.location.href = '/#/contact';  // Redirect to the contact page
};


const HomeMain = () => {
  const [selectedTestimonial, setSelectedTestimonial] = useState(testimonials[0]);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); // Close if the same question is clicked
    } else {
      setActiveIndex(index); // Open the clicked question
    }
  };

    const backgroundImage = 'url(/images/banner.webp)'; // Set the path of your image here


  return (
    <div>
      {/* 🔵 Video Background Section */}
      <section className="home-section">
        <div className="home-video-container">
          <video autoPlay loop muted className="custom-video" poster="">
            <source src="video/hero.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="overlayy"></div>

        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Compliance Made Effortless.
            </h1>

            <p className="hero-subtitle">
              MPS Global integrates finance, legal, and compliance into one seamless
              solution, built for ambitious businesses.
            </p>

            <button
  className="cta-btn"
  onClick={() => {
    // Scroll to the top
    scrollToTop();
    // Navigate to the contact page
    window.location.href = "#/contact";
  }}
>
  Start Your Journey →
</button>

          </div>

          {/* ⭐ Stats Bar */}
          <div className="stats-box">
            <div className="stat-item">
              <h3>15+ Years</h3>
              <p>Of Experience</p>
            </div>

            <div className="divider"></div>

            <div className="stat-item">
              <h3>1600+</h3>
              <p>Active Clients</p>
            </div>

            <div className="divider"></div>

            <div className="stat-item">
              <h3>99.8%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* New Section: About MPS Global */}
      <section className="about-section">
        <div className="about-container">
          {/* Left side Text */}
          <div className="about-text">
            <h2>MPS Global makes starting and running a business simple.</h2>
            <p>
              We remove the complexity from company formation by handling every legal, financial, and compliance requirement for you. From structuring and registrations to filings, tax, contracts, and advisory, everything is managed under one roof.
            </p>
            <p>
              Our approach is designed for entrepreneurs who want to focus on building their product, growing their team, and scaling their vision, while trusting us to build and maintain the foundational legal business needs.
            </p>
            <p>
              At MPS Global, we don’t just provide services. We become your long-term partner, ensuring that your business remains strong, accounts grow, and remains protected at every stage.
            </p>
          </div>

          {/* Right side Images */}
          <div className="about-image-container">
            <div className="about-image">
              <img src="images/about1.webp" alt="Business Assistance 1" className="image" />
            </div>
            <div className="about-image">
              <img src="images/about2.webp" alt="Business Assistance 2" className="image" />
            </div>
          </div>
        </div>
      </section>

      {/* New Section: Expanding Our Global Footprint */}
      <section className="expansion-section">
        <div className="expansion-container">
          {/* Text (centered) */}
          <div className="expansion-text">
            <h2>Expanding Our Global Footprint</h2>
            <p>
              MPS Global is expanding its footprint into Dubai, strengthening our presence across the GCC. This move enables us to serve Middle Eastern clients with faster delivery, local expertise, and globally competitive solutions, reflecting our commitment to innovation and long-term value.
            </p>
          </div>

          {/* Image (below the text) */}
          <div className="expansion-image">
            <img src="images/expanding1.webp" alt="City Skyline" className="image" />
          </div>
        </div>
      </section>

      {/* Core Expertise Section */}
      <section className="core-expertise-section">
      <div className="core-expertise-container">
        <h2>Our Core Expertise That Sets Us Apart</h2>
        <p className="section-desc">
          We don’t just provide services, we deliver clarity, compliance, and growth. 
          Through integrated expertise in Chartered Accountancy, Company Secretarial practices, 
          Finance, and Law, we empower businesses to scale with confidence and precision.
        </p>

        <div className="expertise-cards">
          {/* Card 1 */}
          <div className="expertise-card">
            <img src="images/expertise1.webp" alt="Corporate Law" />
            <div className="overlay-gradient"></div>
            <div className="text-container">
              <h3>Corporate Law</h3>
              <p>We provide expert guidance on corporate governance, legal frameworks, and business operations.</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="expertise-card">
            <img src="images/expertise2.webp" alt="Tax & Audit" />
            <div className="overlay-gradient"></div>
            <div className="text-container">
              <h3>Tax & Audit</h3>
              <p>Offering tax planning, compliance, and audit services to ensure legal and financial transparency.</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="expertise-card">
            <img src="images/expertise3.webp" alt="Finance Advisory" />
            <div className="overlay-gradient"></div>
            <div className="text-container">
              <h3>Finance Advisory</h3>
              <p>Providing financial advisory services to optimize business growth and profitability.</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="expertise-card">
            <img src="images/expertise4.webp" alt="Legal Consulting" />
            <div className="overlay-gradient"></div>
            <div className="text-container">
              <h3>Legal Consulting</h3>
              <p>Offering legal consulting to safeguard your business with comprehensive legal strategies.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Testimonial Section */}
      {/* Testimonial Section */}
      {/* <section className="testimonial-section">
        <h2>Impact That Speaks for Itself</h2>

        <div className="testimonial-content"> */}
          {/* Left side: List of Names */}
          {/* <div className="testimonial-names">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="testimonial-name"
                onClick={() => setSelectedTestimonial(testimonial)}
              >
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="testimonial-image"
                />
                <div className="name-designation">
                  <span>{testimonial.name}</span>
                  <span className="testimonial-designation">
                    {testimonial.designation}
                  </span>
                </div>
              </div>
            ))}
          </div> */}

          {/* Right side: Testimonial Details */}
          {/* <div className="testimonial-details">
            <p className="testimonial-text">{selectedTestimonial.text}</p>
            <div className="testimonial-rating">
              {"★".repeat(selectedTestimonial.rating)}
            </div>
            <p className="testimonial-details-text">{selectedTestimonial.details}</p>
          </div>
        </div>
      </section> */}

      {/* FAQ Section */}
      <section className="faq-section">
       <h2 className="faq-heading">Got Questions? We’ve Got You Covered.</h2>

<p className="faq-description">
  Explore quick answers to help you understand how MPS Global simplifies your business journey.
</p>
        <div className="faq-container">
          {questions.map((item, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question" onClick={() => handleToggle(index)}>
                <span>{item.question}</span>
                <span className="faq-toggle-icon">{activeIndex === index ? '-' : '+'}</span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Dream Team Section */}
      {/* <section className="dream-team-section">
        <h2>Your Dream Team for Business Growth</h2>
        <p>We bring together the best minds in CA, CS, Finance and Law, so you don't have to look anywhere else.</p>
        
        <div className="team-container">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member-card">
              <img
                src={member.image}
                alt={member.name}
                className="team-member-image"
              />
              <div className="team-member-info">
                <p className="team-member-role">{member.role}</p>
                <p className="team-member-name">{member.name}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* bannersection */}
      <section className="banner-section" style={{ backgroundImage }}>
      <div className="banner-container">
        <div className="banner-content">
          <h2>Let’s Build Your Business Together.</h2>
          <div className="banner-buttons">
            <button className="btn-book-consultation" onClick={navigateToContact}>Book a Consultation Now</button>
<button className="btn-contact-us" onClick={navigateToContact}>Contact Us</button>

          </div>
        </div>
      </div>
    </section>

    </div>
  );
};

export default HomeMain;
